// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimelineControlData  {
    _originalTypeClassName = "Loom.BO.TimelineControlData";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimelineControlData.translate = translateService;
}
this.resources = [];
this.events = [];
this.TimelineProjectMonths = [];
this.start = null;
this.end = null;
this.durationInMonths = null;
this.TimelineControlDataKey = null;
this._key = this.TimelineControlDataKey = 0; 
}

static translate: TranslateService;
_key: any;
start:any;
end:any;
durationInMonths:any;
resources:any;
events:any;
TimelineProjectMonths:any;
private _TimelineControlDataKey:any;
get TimelineControlDataKey(): any {
    return this._TimelineControlDataKey;
  }
set TimelineControlDataKey(value: any) {
    this._TimelineControlDataKey = value;
    this._key = value;
  }
static setresources = ($this, items) => {
                if (items == null) items = [];
                if ($this.resources == null) $this.resources = [];

                const copyItems = Common.cloneObject(items);

                while ($this.resources.length > 0) {
                    Domain.TimelineControlData.removeresources($this, $this.resources[0]);
                }

                Domain.TimelineControlData.addManyresources($this, copyItems);
            }
static addManyresources = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TimelineControlData.addresources($this, items[i]);
                }
            }
static addresources = ($this, item) => {
                if ($this.resources == null) $this.resources = [];
                if (item == null || $this.resources.indexOf(item) > -1) return;
                $this.resources.push(item);
}
static addRangeresources = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TimelineControlData.addresources($this, item));
            }
static removeresources = ($this, item) => {
                if ($this == null || $this.resources == null || $this.resources.indexOf(item) === -1) return;
                var _index = $this.resources.indexOf(item);
                $this.resources.splice(_index, 1);
}
static clearresources = ($this) => { $this.resources = null; }
static setevents = ($this, items) => {
                if (items == null) items = [];
                if ($this.events == null) $this.events = [];

                const copyItems = Common.cloneObject(items);

                while ($this.events.length > 0) {
                    Domain.TimelineControlData.removeevents($this, $this.events[0]);
                }

                Domain.TimelineControlData.addManyevents($this, copyItems);
            }
static addManyevents = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TimelineControlData.addevents($this, items[i]);
                }
            }
static addevents = ($this, item) => {
                if ($this.events == null) $this.events = [];
                if (item == null || $this.events.indexOf(item) > -1) return;
                $this.events.push(item);
}
static addRangeevents = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TimelineControlData.addevents($this, item));
            }
static removeevents = ($this, item) => {
                if ($this == null || $this.events == null || $this.events.indexOf(item) === -1) return;
                var _index = $this.events.indexOf(item);
                $this.events.splice(_index, 1);
}
static clearevents = ($this) => { $this.events = null; }
static setTimelineProjectMonths = ($this, items) => {
                if (items == null) items = [];
                if ($this.TimelineProjectMonths == null) $this.TimelineProjectMonths = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TimelineProjectMonths.length > 0) {
                    Domain.TimelineControlData.removeTimelineProjectMonths($this, $this.TimelineProjectMonths[0]);
                }

                Domain.TimelineControlData.addManyTimelineProjectMonths($this, copyItems);
            }
static addManyTimelineProjectMonths = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TimelineControlData.addTimelineProjectMonths($this, items[i]);
                }
            }
static addTimelineProjectMonths = ($this, item) => {
                if ($this.TimelineProjectMonths == null) $this.TimelineProjectMonths = [];
                if (item == null || $this.TimelineProjectMonths.indexOf(item) > -1) return;
                $this.TimelineProjectMonths.push(item);
}
static addRangeTimelineProjectMonths = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TimelineControlData.addTimelineProjectMonths($this, item));
            }
static removeTimelineProjectMonths = ($this, item) => {
                if ($this == null || $this.TimelineProjectMonths == null || $this.TimelineProjectMonths.indexOf(item) === -1) return;
                var _index = $this.TimelineProjectMonths.indexOf(item);
                $this.TimelineProjectMonths.splice(_index, 1);
}
static clearTimelineProjectMonths = ($this) => { $this.TimelineProjectMonths = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TimelineControlDataKey == null || $this.TimelineControlDataKey == 0;
            }


}